<template>
    <div class="w-100 user-chat">
        <div class=""> <!-- card -->
          <div class="chat-users">
            <div class="chat-conversation p-2">
              <simplebar
                style="max-height: 470px"
                id="containerElement"
                ref="current"
              >
                <b-alert :show="!hasChatData">No messages.</b-alert>
                <ul v-if="hasChatData" class="list-unstyled">
                  <li
                    v-for="data of chat_data"
                    :key="data.message"
                    :class="{ right: `${data.align}` === 'right' }"
                  >
                    <div style="max-width: 75%;" class="conversation-list">
                      
                      
                      <b-dropdown
                        variant="white"
                        menu-class="dropdown-menu-end"
                      >
                        <template v-slot:button-content>
                          <i v-if="data.align != 'right' && data.hasRead == 'Read'" class="fas fa-thumbs-up" style="color: limegreen;"></i>
                          <i v-else-if="data.align != 'right' && data.hasRead == 'Unread'" class="fas fa-thumbs-down" style="color: red;"></i>
                          <i v-if="data.align === 'right'" class="bx bx-dots-vertical-rounded"></i>
                        </template>
                        <b-dropdown-item v-if="data.align != 'right' && data.hasRead === 'Unread'" @click="readComment(data.id)">Mark as read</b-dropdown-item>
                        <b-dropdown-item v-if="data.align === 'right'" @click="deleteUserComment(data.id)">Delete</b-dropdown-item>
                        <b-dropdown-item v-if="data.align != 'right' && data.hasRead == 'Read'" disabled>No Action Avaliable</b-dropdown-item>
                      </b-dropdown>
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.user_name }}</div>
                        <p>{{ data.body }}</p>
                        <p class="chat-time mb-0" title="Show read date">
                          <i class="bx bx-time-five align-middle me-1 mb-1"></i>
                          {{ parseDate(data.created_at) }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </simplebar>
            </div>
            <div class="p-2 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input
                      type="text"
                      v-model="form.message"
                      class="form-control chat-input rounded"
                      placeholder="Enter Message..."
                      :class="{
                        'is-invalid': submitted && $v.form.message.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.message.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.message.required"
                        >This value is required.</span
                      >
                    </div>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="Add Link"
                          >
                            <i class="mdi mdi-link-variant"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    type="submit"
                    class="btn btn-primary btn-rounded chat-send w-md"
                  >
                    <span class="d-none d-sm-inline-block me-2">Send</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { parseISO, format} from 'date-fns';
import _ from 'lodash';
import { licenseAppMethods, licenseAppState, clientAdminState } from '@/state/helpers';
import simplebar from "simplebar-vue";
import { required } from "vuelidate/lib/validators";
export default {
    components:{
        simplebar,
    },
    validations: {
        form: {
            message: {
                required,
            },
        },
    },
    data:() => ({
        submitted: false,
        form: {
            message: "",
        },

        //chat_data:[]
    }),
    computed:{
      ...clientAdminState,
      ...licenseAppState,
      hasChatData(){
        if(this.chat_data.length > 0){
          return true;
        }
        else{
          return false;
        }
      },
      chat_data(){
        let comments = _.cloneDeep(this.step_data.comments);
        comments.forEach((comment) => {
          //*Add date key
          comment['date'] = new Date(comment.created_at)
          comment['hasRead'] = ''
          if(comment.type == 'client_comment'){
            comment['align'] = 'right';
          }
          else{
            if(comment.tracking.read_user_id != undefined){
              if(comment.tracking.read_user_id == this.core_data.id){
                comment['hasRead'] = 'Read'
              }
              else{
                comment['hasRead'] = 'Unread'
              }
            }
            else{
              comment['hasRead'] = 'Unread'
            }
          }
        });
        comments = _.sortBy(comments, ['date']);
        return comments;
      }
    },
    methods:{
      ...licenseAppMethods,

      parseDate(raw_date){
        let date = format(parseISO(raw_date), 'dd MMM yyyy');
        let time = format(parseISO(raw_date), 'HH:mm a');
        return date + ' - ' + time;
      },

      update(){
        this.loadStepData(this.step_data.id)
        .then(()=>{
          this.handleScroll();
        });
      },

        // eslint-disable-next-line no-unused-vars
        formSubmit(e) {
            this.submitted = true;

            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let params = {
                  step_id: this.step_data.id,
                  comment: this.form.message,
                }
                this.saveComment(params)
                .then(()=>{
                  this.update();
                })
                .catch(()=>{
                  alert('Error saving');
                })
              
                /*const message = this.form.message;
                const currentDate = new Date();
                this.chat_data.push({
                    align: "right",
                    name: "Henry Wells",
                    message,
                    time: currentDate.getHours() + ":" + currentDate.getMinutes(),
                });*/
                //this.handleScroll();
            }
            this.submitted = false;
            this.form = {};
        },
        handleScroll() {
            if (this.$refs.current.$el) {
                setTimeout(() => {
                    this.$refs.current.SimpleBar.getScrollElement().scrollTop =
                    this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
                }, 500);
            }
        },
        readComment(id){
          let params = {
            client_step_action_id: id,
          }
          this.markAction(params)
          .then(()=>{
            this.update()
          })
          .catch(()=>{
            alert('Error');
          })
        },
        deleteUserComment(id){
          let params = {
            id: id
          }
          this.deleteComment(params)
          .then(()=>{
            /*alert('Deleted')
            this.loadStepData(this.step_data.id)
            .then(()=>{
              this.handleScroll();
            });*/
            this.update();
          })
        }
    },
    mounted(){
        var container2 = document.querySelector(
            "#containerElement .simplebar-content-wrapper"
        );
        container2.scrollTo({ top: 500, behavior: "smooth" });
    },
}
</script>

<style>
.chat-conversation .right .conversation-list .ctext-wrap{
  background-color: #dffff3 !important;
}
</style>